<template>
  <el-drawer
    :key="drawerVisible"
    title="关联原材料订单"
    :visible.sync="drawerVisible"
    append-to-body
    direction="rtl"
    size="86%"
  >
    <div class="drawer-container">
      <div class="drawer-content">
        <div class="tabs-content">
          <el-tabs
            v-model="activeName"
            class="tabs-area"
            type="card"
            @tab-click="handleClick"
          >
            <el-tab-pane label="原材料采购订单" name="1"></el-tab-pane>
            <el-tab-pane label="库存订单" name="2"></el-tab-pane>
            <el-tab-pane label="成品现货" name="3"></el-tab-pane>
          </el-tabs>
        </div>
        <template v-if="activeName !== '3'">
          <div class="search-box">
            <ESearch
              :data="listQuery"
              :field-list="fieldList"
              @handleFilter="handleFilter"
              @handleReset="handleReset"
            ></ESearch>
          </div>
          <div class="table-wrapper">
            <div class="table-content">
              <div class="table-left">
                <div class="table-op">
                  <span>待关联订单</span>
                  <eui-btn v-if="activeName === '2'" @click="goToCreate"
                    >创建库存订单</eui-btn
                  >
                </div>
                <div class="list-box">
                  <TableList
                    ref="leftTableRef"
                    :table-data="leftTableData"
                    :table-label="leftTableLabel"
                    row-key="id"
                    :loading="tableLoading"
                    selection-show
                    :check-selectable="checkboxSelect"
                    @handleSelect="handleSelectLeftOne"
                    @handleSelectAll="handelSelectLeftAll"
                  ></TableList>
                </div>

                <div class="pagination">
                  <el-pagination
                    :pager-count="5"
                    layout="total, prev, pager, next"
                    :current-page="listQuery.pageNum"
                    :total="total"
                    :page-size.sync="listQuery.pageSize"
                    prev-text="上一页"
                    next-text="下一页"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                  ></el-pagination>
                </div>
              </div>
              <div class="table-center">
                <eui-btn @click="addSelectedList">
                  添加
                  <eui-icon icon="eicon-arrow-right"></eui-icon>
                </eui-btn>
                <eui-btn style="margin: 10px 0 0 0" @click="deleteCompany">
                  <eui-icon icon="eicon-arrow-left"></eui-icon>
                  删除
                </eui-btn>
              </div>
              <div class="table-right">
                <div class="table-op">已关联订单</div>
                <div class="list-box">
                  <TableList
                    ref="rightTableRef"
                    :table-data="rightTableData"
                    :table-label="rightTableLabel"
                    row-key="id"
                    selection-show
                    max-height="397"
                    @handleSelectionChange="rightHandleSelectionChange"
                  ></TableList>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div v-show="activeName === '3'">
          <div class="tip-wrap">
            <div class="red">提示：</div>
            <div class="content" style="padding: 0">
              <p>
                "成品现货"是指是企业有成品现货库存，可直接录入成品现货的简要信息（如供应商名称、质检报告、合同信息等）。
              </p>
            </div>
          </div>
          <div style="padding: 0 20px">
            <el-form
              ref="formName"
              :model="formData"
              label-width="200px"
              :rules="rules"
            >
              <el-form-item
                label="原材料供应商名称："
                prop="materialSupplierCompanyName"
              >
                <el-input
                  v-model="formData.materialSupplierCompanyName"
                  placeholder="请输入原材料供应商名称"
                  disabled
                  style="width: 282px; height: 30px"
                >
                </el-input>
                <eui-btn
                  type="weak"
                  class="margin-l20"
                  @click="stockDialogVisible = true"
                  >选择供应商</eui-btn
                >
              </el-form-item>
              <el-form-item label="备注：" prop="remark">
                <el-input
                  v-model="formData.remark"
                  type="textarea"
                  :rows="4"
                  placeholder="请输入备注"
                  maxlength="300"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
            </el-form>
            <!--品类、采购合同上传、附件整合-->
            <common-upload
              ref="commonRef"
              :supplier-company-id="formData.materialSupplierCompanyId"
              :form-data="formDataValue"
              :ai-audit-type="3"
              :key="activeName"
            />
          </div>
        </div>
      </div>
      <div class="drawer-footer">
        <eui-btn @click="onCancel">取消</eui-btn>
        <eui-btn @click="beforeConfirm">确定</eui-btn>
      </div>

      <!--选择供应商-->
      <StockDialog
        :visible.sync="stockDialogVisible"
        @getSupplierInfo="getSupplierInfo"
      />
      <!--选择了石化保供信息，且供应商不在维护清单中，提示   -->
      <sub-supplier-dialog
        v-if="showSubSupplierTip"
        :showSubSupplierTip.sync="showSubSupplierTip"
      />
    </div>
  </el-drawer>
</template>

<script>
import ESearch from '@/modules/projectA/components/common/e-search';
import TableList from '@/modules/projectA/components/common/e-table-list.vue';
import api from '@/modules/projectA/api/order';
import userApi from '@/modules/projectA/api/user';
import { epecToken } from '@/modules/projectA/utils/globalData';
import _ from 'lodash';
import StockDialog from '../../stockOrder/components/StockDialog.vue';
import {
  listQuery,
  orderDrawerFieldList,
  orderDrawerTableLabelAll as tableLabelAll,
  rightOrderDrawerTableLabel as rightTableLabel,
} from '../../common/purchasingPlan';

import commonUpload from '../../components/commonUpload';
import subSupplierDialog from '../../components/subSupplierDialog';

export default {
  components: {
    ESearch,
    TableList,
    StockDialog,
    commonUpload,
    subSupplierDialog,
  },
  props: {
    visible: Boolean,
    purchasePlanId: {
      type: Number,
      required: true,
    },
    availableParent: String,
  },
  data() {
    return {
      stockDialogVisible: false,
      uploadUrl: api.orderAttachUpload,
      headers: epecToken,
      rules: {
        materialSupplierCompanyName: [
          {
            required: true,
            message: '请输入原材料供应商名称',
            trigger: 'change',
          },
        ],
      },
      supplierAttachList: [],
      labelVisible: false,
      available: '0', // 是否现货
      formDataValue: {},
      formData: {
        contractAttachList: [], // 采购合同
        attachList: [],
        materialSupplierCompanyName: '', // 必传
        materialSupplierCompanyId: '', // 非必传
        remark: '',
        oneCategoryValue: '',
        twoCategoryValue: '',
        threeCategoryValue: '',
        lbbm: '',
        categoryId: '',
      },
      tableLoading: false,
      activeName: '1',
      listQuery,
      tableLabelAll,
      orderDrawerFieldList,
      total: 0,

      leftTableData: [],
      leftTableDataAll: [],
      leftSelectedList: [],
      ecPurchasePlanIdList: [],

      rightTableLabel,
      rightTableData: [],
      rightSelectedList: [],

      showSubSupplierTip: false,
    };
  },
  computed: {
    drawerVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
    leftTableLabel() {
      if (this.activeName === '3') return [];
      return this.tableLabelAll.filter((item) => {
        if (item.hide === this.activeName) {
          return false;
        }
        return true;
      });
    },
    fieldList() {
      if (this.activeName === '3') return [];
      return this.orderDrawerFieldList.filter((item) => {
        if (item.hide === this.activeName) {
          return false;
        }
        return true;
      });
    },
  },
  watch: {
    visible: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.formData = {
            attachList: [],
            materialSupplierCompanyName: '', // 必传
            materialSupplierCompanyId: 0, // 非必传
            remark: '',
          };
          this.listQuery = {
            orderNo: '',
            companyName: '',
            start: '',
            end: '',
            pageNum: 1,
            pageSize: 10,
          };

          this.listQuery.pageNum = 1;
          this.activeName = '1';

          this.getList();
          this.getRightList();
        }
      },
    },
    availableParent: {
      handler(newVal) {
        // console.log(typeof newVal,newVal)
        if (newVal === '-1') {
          this.available = '0';
        } else {
          this.available = newVal;
        }
      },
    },
  },
  created() {
    this.cloneListQuery = _.cloneDeep(this.listQuery);
    console.log(this.formData, 'this.formData');
  },
  methods: {
    getSupplierInfo(supplierInfo) {
      const { supplierCompanyName, supplierCompanyId } = supplierInfo;
      this.formData.materialSupplierCompanyName = supplierCompanyName;
      this.formData.materialSupplierCompanyId = supplierCompanyId;
      console.log(
        this.formData.materialSupplierCompanyId,
        'this.formData.materialSupplierCompanyId'
      );
    },
    goToCreate() {
      this.$router.push({
        path: '/rawMaterialOrder/stockOrder/newStock',
      });
    },
    onCancel() {
      this.drawerVisible = false;
      this.listQuery = { ...this.cloneListQuery };
    },
    async getRightList() {
      try {
        const { purchasePlanId } = this;
        const { data = [], code } = await api.queryBind({ purchasePlanId });
        if (code === '200') {
          const { bindList, materialSupplierList } = data || {};

          bindList.forEach((item) => {
            item.typeName = item.type === 1 ? '采购订单' : '库存订单';
          });
          this.rightTableData = [...bindList];
          this.leftSelectedList = [...bindList];

          this.ecPurchasePlanIdList = this.rightTableData.map(
            (item) => item.id
          );

          this.formData.materialSupplierCompanyName =
            materialSupplierList !== undefined
              ? materialSupplierList[0].materialSupplierCompanyName
              : '';
          this.formData.remark =
            materialSupplierList !== undefined
              ? materialSupplierList[0].remark
              : '';
          this.formData.materialSupplierCompanyId =
            materialSupplierList !== undefined
              ? materialSupplierList[0].materialSupplierCompanyId
              : '';
          this.formDataValue =
            materialSupplierList !== undefined ? materialSupplierList[0] : {};
          console.log(
            this.formDataValue,
            'this.formDataValuethis.formDataValuethis.formDataValue'
          );

          // this.rightTableData.forEach(item => {
          //   this.$refs.leftTableRef.$refs.table.toggleRowSelection(item, true);
          // })
        }
      } catch (error) {
        console.error(error);
      }
    },
    getParams() {
      if (this.listQuery.createTime?.length) {
        const [start, end] = this.listQuery.createTime;
        this.listQuery.startTime = start;
        this.listQuery.endTime = end;
      }
      const params =
        this.activeName === '1'
          ? {
              orderNo: this.listQuery.orderNo,
              supplierCompany: this.listQuery.companyName,
              startAmount: this.listQuery.start,
              endAmount: this.listQuery.end,
              startTime: this.listQuery.startTime,
              endTime: this.listQuery.endTime,
            }
          : {
              seqNo: this.listQuery.seqNo,
              supplierCompanyName: this.listQuery.companyName,
              priceBegin: this.listQuery.start,
              priceEnd: this.listQuery.end,
              purchaseDateBegin: this.listQuery.startTime,
              purchaseDateEnd: this.listQuery.endTime,
            };
      return {
        ...params,
        pageNum: this.listQuery.pageNum,
        pageSize: this.listQuery.pageSize,
      };
    },
    async getList() {
      try {
        const params = this.getParams();
        const { purchaseListOrder, ecStockQueryPage } = api;
        const method =
          this.activeName === '1' ? purchaseListOrder : ecStockQueryPage;
        this.tableLoading = true;
        const { data = {}, code } = await method(params);
        if (code === '200') {
          const { records = [], total = 0 } = data;
          this.leftTableData = records.map((item) => {
            return {
              no: item.orderNo || item.seqNo,
              id: item.orderId || item.id,
              supplierCompany: item.supplierCompany || item.supplierCompanyName,
              price: item.needPay || item.price,
              type: Number(this.activeName),
              typeName: this.activeName === '1' ? '采购订单' : '库存订单',
              state: item.orderStatus || '',
              createTime: item.submitTime || item.purchaseDate,
              supplierCompanyId: item.supplierCompanyId || '',
            };
          });

          this.total = total;

          this.$nextTick(() => {
            this.leftTableData.forEach((item) => {
              if (this.ecPurchasePlanIdList.includes(item.id)) {
                this.$refs.leftTableRef.$refs.table.toggleRowSelection(
                  item,
                  true
                );
              }
            });
          });
        }
      } catch (error) {
        console.error(error);
        // this.leftTableData = [];
      } finally {
        this.tableLoading = false;
      }
    },
    // 都需要进行字段适配
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },
    handleFilter(val) {
      this.listQuery = { ...val };
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    },
    handleReset() {
      this.listQuery = {
        ...this.cloneListQuery,
      };
      this.getList(this.listQuery);
    },
    checkboxSelect(row) {
      const indexNum = this.rightTableData.findIndex(
        (item) => item.id === row.id
      );
      if (indexNum === -1) {
        return true;
      }
      return false;
    },
    // 左侧操作  全选或者全不选
    handelSelectLeftAll(val) {
      this.leftSelectedList = JSON.parse(JSON.stringify(val));
    },
    // 操作左侧当前 一条
    handleSelectLeftOne(val) {
      const { row, rows } = val;

      if (this.leftSelectedList.length > 0) {
        const whetherExist = rows.filter((item) => item.id === row.id);

        if (whetherExist.length > 0) {
          // 不存在
          this.leftSelectedList.push({ ...row });
        } else {
          const leftSelectedListIndexNum = this.leftSelectedList.findIndex(
            (item) => item.id === row.id
          );
          this.leftSelectedList.splice(leftSelectedListIndexNum, 1);
        }
      } else {
        this.leftSelectedList.push({ ...row });
      }
    },

    rightHandleSelectionChange(val) {
      this.rightSelectedList = val;
    },
    deleteCompany() {
      const ids = this.rightSelectedList.map((item) => item.id);

      this.rightTableData = this.rightTableData.filter(
        (item) => !ids.includes(item.id)
      );
      this.ecPurchasePlanIdList = this.rightTableData.map((item) => item.id);

      this.$nextTick(() => {
        this.$refs.rightTableRef.$refs.table.clearSelection();
      });
    },
    handleClick() {
      this.listQuery = { ...this.cloneListQuery };
      this.getList();
    },
    // 往右侧添加数据
    addSelectedList() {
      if (this.rightTableData.length > 500) {
        this.$message.warning('最多500条');
        return;
      }
      this.rightTableData = [];
      this.rightTableData = JSON.parse(JSON.stringify(this.leftSelectedList));
    },

    async purchasePlanBind(params) {
      const { code } = await api.purchasePlanBind(params);
      if (code === '200') {
        this.handleConfirm();
      }
    },

    async beforeConfirm() {
      // 成品现货供应商
      let supplierCompanyIdList = [];
      let currentSupplierCompanyName = '';
      if (this.activeName === '3') {
        const res = await this.$refs.formName.validate();

        if (!res) {
          return false;
        }
        // currentSupplierCompanyName = this.formData.materialSupplierCompanyName;
      }
      currentSupplierCompanyName = this.formData.materialSupplierCompanyName;
      if (this.activeName === '1' || this.activeName === '2') {
        // const supplierCompanyIdArr = this.rightTableData.filter(
        //   (item) => item.supplierCompanyId
        // );
        // supplierCompanyIdList = supplierCompanyIdArr.map(
        //   (item) => item.supplierCompany
        // );
      }
      const supplierCompanyIdArr = this.rightTableData.filter(
        (item) => item.supplierCompany
      );
      supplierCompanyIdList = supplierCompanyIdArr.map(
        (item) => item.supplierCompany
      );

      // 选择了石化保供信息，且供应商不在维护清单中，提示
      // 判断supplierCompanyIdList是数组时判断数组长度，不是数组时判断字符串长度
      if (currentSupplierCompanyName) {
        const res = await userApi.isSubSupplier({
          supplierCompanyNameList: [currentSupplierCompanyName],
        });
        let subSupplierData = [];
        if (res.code === '200') {
          subSupplierData = res.data.filter((item) => !item.flag);
        }

        if (subSupplierData.length > 0) {
          this.showSubSupplierTip = true;
          return false;
        }
      }

      if (this.formData.materialSupplierCompanyName) {
        // 有供应商校验附件等必传
        const validateRes =
          await this.$refs.commonRef.$refs.commonUpload.validate();
        if (this.activeName === '3') {
          if (validateRes) {
            this.onConfirm();
          }
        } else if (!validateRes) {
          this.$message.warning('成品现货页签有信息未填写，请填写必输项。');
        } else {
          this.onConfirm();
        }
      } else {
        this.onConfirm();
      }
    },
    async onConfirm() {
      let params = {};
      const { purchasePlanId } = this;
      const { ruleForm } = this.$refs.commonRef;

      const bindList = this.rightTableData.map((item) => ({
        id: item.id,
        type: item.type,
      }));
      let materialSupplierList = [];
      const {
        attachList,
        materialSupplierCompanyName,
        materialSupplierCompanyId,
        remark,
      } = this.formData;
      if (
        attachList.length > 0 ||
        materialSupplierCompanyName ||
        materialSupplierCompanyId ||
        remark
      ) {
        materialSupplierList = [{ ...this.formData, ...ruleForm }];
      }

      params = {
        purchasePlanId,
        bindList,
        materialSupplierList,
      };
      this.purchasePlanBind(params);
    },
    async modifyAvailable(params) {
      const { code } = await api.modifyAvailable(params);
      if (code === '200') {
        this.handleConfirm();
      }
    },
    handleConfirm() {
      this.$message.success('关联成功');
      this.drawerVisible = false;
      this.$emit('refresh');
      if (this.available === '0') {
        this.$nextTick(() => {
          this.$refs.rightTableRef.$refs.table.clearSelection();
        });
      }
    },
    // 是现货，查看已关联的供应商及附件
    async materialSupplierList() {
      const { code, data } = await api.materialSupplierList({
        id: this.purchasePlanId,
      });
      if (code === '200' && data.length > 0) {
        this.formData.attachList = data[0].attachList || [];
        this.formData.materialSupplierCompanyName =
          data[0].materialSupplierCompanyName || '';
      } else {
        this.formData.attachList = [];
        this.formData.materialSupplierCompanyName = '';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  min-height: 0;
}
.drawer-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .tip-word {
    margin-left: 10px;
    color: #999;
  }

  .attach-mapper {
    display: grid;
    grid-template-columns: repeat(auto-fill, 250px);
    grid-template-rows: auto;
    column-gap: 20px;
    row-gap: 10px;
    margin-top: 10px;

    .attach-box {
      width: 250px;
      height: 60px;
      padding: 6px 10px;
      background: linear-gradient(
        90deg,
        #f5f5f5 0%,
        rgba(245, 245, 245, 0.2) 100%
      );

      .cursor-show {
        cursor: pointer;
      }

      .attach-left {
        width: 216px;

        .flex-start {
          display: flex;
          align-items: center;
        }

        .margin-t5 {
          margin-top: 5px;
        }

        .label-item {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 80px;
          height: 20px;
          border: 1px solid #d9d9d9;
          margin-right: 6px;
          color: #666;
          font-size: 12px;
          cursor: pointer;
          background-color: #fff;

          &:hover {
            background-color: #e9f3ff;
            border-color: #2587ff;
            color: #2587ff;
          }
        }

        .choose-label {
          width: 100px;
          height: 20px;
          line-height: 18px;
          border: 1px solid #2587ff;
          color: #2587ff;
          font-size: 12px;
          text-align: center;
          cursor: pointer;

          &:hover {
            background-color: #e9f3ff;
          }
        }
      }

      .attach-right {
        margin-top: 10px;
        cursor: pointer;
      }

      .file-name {
        color: #0064c8;
        font-size: 14px;
        line-height: 1.1;
      }
    }

    ::v-deep .el-form-item--small .el-form-item__content {
      line-height: 24px;
    }
  }

  .tip-wrap {
    display: flex;
    background-color: #e8efff;
    padding: 10px 20px;
    font-size: 14px;
    margin: 0 10px;
    margin-bottom: 20px;

    .red {
      color: #ef4c56;
      display: inline-block;
    }
  }
  .drawer-content {
    flex: 1;
    overflow-y: auto;
    min-height: 0;

    .available-wrapper {
      font-size: 14px;
      margin-left: 10px;
    }
    .table-op {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 30px;
    }
    .tabs-content {
      padding: 10px;
    }
    .table-wrapper {
      flex: 1;
      .table-content {
        display: flex;
        padding: 0 10px;
        max-width: 100%;
        width: 100%;
        .table-left {
          flex: 1;
          min-width: 0;
        }
        .table-center {
          flex: none;
          align-self: center;
          text-align: center;
          width: 100px;
        }
        .table-right {
          min-width: 0;
          flex-shrink: 0;
          max-width: 420px;
        }

        .list-box {
          margin-top: 10px;
          max-width: 100%;
        }
        .add-sup {
          color: #0064c8;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }

        .del-btn {
          color: #f0250f;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
  .drawer-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
  }
}
</style>
